import React, {Component} from "react";
import {connect} from "react-redux";
import {Tab} from "@mui/material";
import SendTimeExtensionOutlinedIcon from '@mui/icons-material/SendTimeExtensionOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import BackupIcon from '@mui/icons-material/Backup';
import {TabContext, TabList, TabPanel} from "@mui/lab";
import ExportSettingsView from "./export_settings";
import ScanSettingsView from "./scan_settings";
import BackupSettingsView from "./backup_settings";
import SharedUrlsView from "./shared_urls";
import ScanningProfileView from "../../view/scanning_profile";
import {SettingsOverscanOutlined} from "@mui/icons-material";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import {aclPermissions, hasPermissions} from "const/ACLPermissions";
import {getUnauthorizedComponent} from "component/dashboard/slidelist_utils";
import {isCloud, isSuperuser} from "../../utils/utils";
import CreateUser from "../../view/createUser";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import BuildIcon from '@mui/icons-material/Build';
import ListAltIcon from '@mui/icons-material/ListAlt';
import {ReactComponent as IconTile} from "../../asset/dashboard/tile.svg";
import AddTiledView from "../../view/addtiledview";
import ServicesView from "../../view/Services";
import Thresholder from "../../view/thresholder";
import AuditLogDump from "../../view/downloadauditlogdump"

class GeneralSettingsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "0"
        }
    }

    onTabChange = (event, value) => {
        this.setState({activeTab: value});
    }

    render() {
        if (!hasPermissions([aclPermissions.general_setting_menu])) {
            return getUnauthorizedComponent()
        }

        return (
            <div className={'full-parent'} style={{display: 'flex', flexDirection: 'column'}}>
                <TabContext value={this.state.activeTab}>
                    <TabList
                        onChange={this.onTabChange}
                        indicatorColor="secondary"
                        textColor="secondary"
                        sx={{backgroundColor: "#fff"}}
                    >
                        {hasPermissions([aclPermissions.anonymous_share]) &&
                            <Tab icon={<GroupsOutlinedIcon/>} iconPosition="start" label="Share" value="0"/>}
                        {!isCloud() && hasPermissions([aclPermissions.modify_export_settings]) &&
                            <Tab icon={<SendTimeExtensionOutlinedIcon/>} iconPosition="start" label="Export"
                                 value="1"/>}
                        {!isCloud() && hasPermissions([aclPermissions.modify_export_settings]) &&
                            <Tab icon={<SendTimeExtensionOutlinedIcon/>} iconPosition="start" label="Scan"
                                 value="9"/>}
                        {!isCloud() && hasPermissions([aclPermissions.backup_database]) &&
                            <Tab icon={<BackupIcon/>} iconPosition="start" label="Backup"
                            value="2"/>}

                        {!isCloud() && hasPermissions([aclPermissions.update_specimen_setting]) &&
                            <Tab icon={<SettingsOverscanOutlined/>} iconPosition="start" label="Scanning Profile"
                                 value="3"/>}
                        {isSuperuser() && !isCloud() &&
                            <Tab icon={<PersonAddIcon/>} iconPosition="start" label="Setup Wizard" value="4"/>}
                        {isSuperuser() && <Tab icon={<IconTile width={"20px"} height={"20px"}/>} iconPosition="start"
                                               label="Add Tiled Scan" value="5"/>}
                        {isSuperuser() && <Tab icon={<BuildIcon/>} iconPosition="start" label="Services" value="6"/>}
                        {isSuperuser() &&
                            <Tab icon={<ListAltIcon/>} iconPosition="start" label="Thresholder" value="7"/>}
                        {hasPermissions([aclPermissions.download_audit_logs]) &&
                        <Tab icon={<CloudDownloadIcon/>} label={"Download Audit Logs"} value={"8"} iconPosition="start"></Tab>}
                    </TabList>
                    {hasPermissions([aclPermissions.anonymous_share]) && <TabPanel value="0" sx={{flex: 1}}>
                        <SharedUrlsView/>
                    </TabPanel>}
                    {!isCloud() && hasPermissions([aclPermissions.modify_export_settings]) &&
                        <TabPanel value="1" sx={{flex: 1}}>
                            <ExportSettingsView/>
                        </TabPanel>}
                    {!isCloud() && hasPermissions([aclPermissions.modify_export_settings]) &&
                        <TabPanel value="9" sx={{flex: 1}}>
                            <ScanSettingsView/>
                        </TabPanel>}
                    {!isCloud() && hasPermissions([aclPermissions.modify_export_settings]) &&
                        <TabPanel value="2" sx={{flex: 1}}>
                            <BackupSettingsView/>
                        </TabPanel>}
                    {!isCloud() && hasPermissions([aclPermissions.update_specimen_setting]) &&
                        <TabPanel value={"3"} sx={{flex: 1}}>
                            <ScanningProfileView/>
                        </TabPanel>}
                    <TabPanel value={"4"} sx={{flex: 1}}>
                        {isSuperuser() && !isCloud() && <CreateUser/>}
                    </TabPanel>
                    <TabPanel value={"5"} sx={{flex: 1}}><AddTiledView/></TabPanel>
                    <TabPanel value={"6"} sx={{flex: 1}}><ServicesView/></TabPanel>
                    <TabPanel value={"7"} sx={{flex: 1}}><Thresholder/></TabPanel>
                    <TabPanel value={"8"} sx={{flex: 2}}><AuditLogDump/></TabPanel>
                </TabContext>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(mapStateToProps)(GeneralSettingsView);
